import { BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import { useAppSelector } from "../../redux/store";
import { MainRouting } from "../../routing/MainRouting/MainRouting";
import { getIsShowLoader } from "../../redux/reducers/app/appSelectors";
import { Loader } from "../../processes/modals/Loader/Loader";
import PlayCanvasService from "../../services/PlayCanvasService/PlayCanvasService";

export const MainPage = () => {
  const isShowLoader = useAppSelector(getIsShowLoader());
console.log("test");
  // Global PlayCanvas initialization - runs once when app starts
  useEffect(() => {
    const initializeGlobalPlayCanvasSettings = async () => {
      try {
        await PlayCanvasService.initializePlayCanvasOverrides();
        console.log("🌍 Global PlayCanvas settings initialized successfully");
      } catch (error) {
        console.warn(
          "⚠️ Failed to initialize global PlayCanvas settings:",
          error
        );
      }
    };

    initializeGlobalPlayCanvasSettings();
  }, []);

  if (isShowLoader) {
    return <Loader />;
  }

  return (
    <BrowserRouter>
      <MainRouting />
    </BrowserRouter>
  );
};
